import React, { Component } from 'react';
import { Field, reduxForm } from 'redux-form';
import submit from './submit';
import validate from './validate';
import cx from 'classnames';
import {
  Button,
  FormGroup,
  Col,
  FormControl,
  Panel,
  Grid,
  Row
} from 'react-bootstrap';
import withStyles from 'isomorphic-style-loader/withStyles';
import s from './WhyHostFormBlock1.css';
import bt from '../../../../components/commonStyle.css';
import Image from './Image'

// Translation
import { FormattedMessage, injectIntl } from 'react-intl';
import messages from '../../../../locale/messages';
import InputFieldComponent from '../../../Common/FormField/InputFieldComponent';

class WhyHostFormBlock1 extends Component {


  render() {

    const { error, handleSubmit, submitting, dispatch, initialValues } = this.props;
    const { formatMessage } = this.props.intl;

    return (
      <Grid fluid>
        <Row>
          <Col lg={12} md={12} sm={12} xs={12}>
            <h1 className={s.siteAdminHeading}><FormattedMessage {...messages.whyBecomeHostBlock1} /></h1>
          </Col>
          <Col xs={12} sm={12} md={9} lg={8} className={s.blockCenter}>
            <Panel className={cx(s.panelHeader)}>
              <form onSubmit={handleSubmit(submit)}>
                {error && <strong>{formatMessage(error)}</strong>}
                <FormGroup className={bt.space4}>
                  <label className={s.labelTextNew} ><FormattedMessage {...messages.hostBannerLabel} /></label>
                  <Image />
                </FormGroup>
                <Field
                  name="hostBannerTitle1"
                  type="text"
                  component={InputFieldComponent}
                  placeholder={formatMessage(messages.hostBannerPlaceHolder)}
                  label={formatMessage(messages.hostBannerTitle)}
                  inputClass={bt.commonControlInput}
                  formGroupClass={bt.space4}
                />
                <div className='singleButtonFlexEnd'>
                  <Button className={cx(bt.btnPrimary, bt.btnLarge)} type="submit" disabled={submitting}>
                    <FormattedMessage {...messages.save} />
                  </Button>
                </div>
              </form>
            </Panel>
          </Col>
        </Row>
      </Grid>
    );
  }

}

WhyHostFormBlock1 = reduxForm({
  form: 'WhyHostForm',
  validate
})(WhyHostFormBlock1);

export default injectIntl(withStyles(s, bt)(WhyHostFormBlock1));